import React, { useEffect, useState } from "react";
import Main from "../components/admin/Main";
import PageContainer from "../components/admin/PageContainer";
import Modal from "../components/admin/Modal";
import CollapseCard from "../components/admin/CollapseCard";
import { useToast } from "../components/toast/ToastProvider";
import {
  fetchProductImage,
  createProductImage,
  updateProductImage,
  deleteProductImage,
} from "../service/ProductImageService";
import ProductImageForm from "../components/admin/ProductImageForm";
import ProductsImageList from "../components/admin/ProductImageList";

const ProductImagePage = () => {
  const [showModal, setShowModal] = useState(false);
  const [productImageData, setProductImageData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const toast = useToast();

  const fetchData = async () => {
    try {
      const res = await fetchProductImage();
      setProductImageData(res);
    } catch (error) {
      toast("Failed to load product images", "error");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle save (create or update)
  const handleSave = async (formData) => {
    try {
      if (selectedData && selectedData.id) {
        // Update existing
        await updateProductImage(selectedData.id, formData);
        toast("Product image updated successfully", "SUCCESS");
      } else {
        // Create new
        await createProductImage(formData);
        toast("Product image added successfully", "SUCCESS");
      }

      setShowModal(false);
      setSelectedData(null);
      fetchData(); // Refresh list
    } catch (error) {
      console.error("Save error:", error);
      toast("Failed to save product image", "ERROR");
    }
  };

  const handleEdit = (data) => {
    // Pass full data including id and imageUrl
    setSelectedData(data);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      try {
        await deleteProductImage(id);
        toast("Product image deleted successfully", "SUCCESS");
        fetchData();
      } catch (error) {
        toast("Failed to delete product image", "ERROR");
      }
    }
  };

  return (
    <Main>
      <PageContainer
        title="Product Image Management"
        buttonText="ADD IMAGE"
        onButtonClick={() => {
          setSelectedData(null);
          setShowModal(true);
        }}
      >
        {/* Add/Edit Modal */}
        <Modal
          visible={showModal}
          size="xl"
          onClose={() => {
            setShowModal(false);
            setSelectedData(null);
          }}
          headerText={selectedData ? "Edit Product Image" : "Add Product Image"}
          centered
        >
          <ProductImageForm
            initialValues={selectedData}
            onSubmit={handleSave}
          />
        </Modal>

        {/* Product Image List */}
        <CollapseCard title="Product Image List">
          <ProductsImageList
            productImageData={productImageData}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default ProductImagePage;